import { apiRequest } from "../../lib/api-client";

export type InviteContext = {
  host_name: string;
  purpose: string;
  expected_exit: string | null;
  email: string;
  expires_at: string;
  already_completed: boolean;
  tenant_company_code: string;
  required_fields: string[];
};

export function getInviteContext(token: string) {
  return apiRequest<InviteContext>(`/invites/${encodeURIComponent(token)}`);
}

export type InviteCompletePayload = {
  fullName: string;
  phone: string;
  companyName: string;
  notes: string;
  idType: string;
  idNumber: string;
  hasLaptop: boolean;
  laptopMac: string;
  laptopSerial: string;
  photo: File | null;
  idDocument: File | null;
};

export function completeInvite(token: string, payload: InviteCompletePayload) {
  const form = new FormData();
  form.set("full_name", payload.fullName);
  if (payload.phone) form.set("phone", payload.phone);
  if (payload.companyName) form.set("company_name", payload.companyName);
  if (payload.notes) form.set("notes", payload.notes);
  if (payload.idType) form.set("id_type", payload.idType);
  if (payload.idNumber) form.set("id_number", payload.idNumber);
  form.set("has_laptop", String(payload.hasLaptop));
  if (payload.hasLaptop && payload.laptopMac) form.set("laptop_mac_address", payload.laptopMac);
  if (payload.hasLaptop && payload.laptopSerial) form.set("laptop_serial_number", payload.laptopSerial);
  if (payload.photo) form.set("photo", payload.photo);
  if (payload.idDocument) form.set("id_document", payload.idDocument);

  return apiRequest<{ visit_id: number; status: string }>(`/invites/${encodeURIComponent(token)}/complete`, {
    method: "POST",
    body: form,
  });
}
